// §C (Addendum June 2026): GA-triggered patient education checklist config
// Admin-configurable GA window boundaries stored at settings/educationChecklistConfig.
// All three enforcement points (PatientEducationChecklistInput, soft prompt logic) read
// from these constants so a practice-level change updates all consumers simultaneously.

export type GaWindow = 'first-trimester' | 'second-trimester' | 'third-trimester' | 'postpartum'

export interface EducationChecklistConfig {
  /** Last GA day (inclusive) in the first-trimester window — default 97 (<14w0d) */
  firstTrimesterEndDays: number
  /** Last GA day (inclusive) in the second-trimester window — default 195 (≤27w6d) */
  secondTrimesterEndDays: number
}

export const DEFAULT_EDUCATION_CHECKLIST_CONFIG: EducationChecklistConfig = {
  firstTrimesterEndDays: 97,
  secondTrimesterEndDays: 195,
}

export const EDUCATION_CHECKLIST_CONFIG_DOC = 'educationChecklistConfig'

// Named constants consumed by non-hook contexts (analogous to GBS_GA_TRIGGER_DAYS)
export const FIRST_TRIMESTER_END_DAYS = 97
export const SECOND_TRIMESTER_END_DAYS = 195
